import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ERRORCODE } from 'config';
import { UserModel } from '../manage-users';
import { PageLoaderService } from "lib/ng2-sapmp/src/ui-components/page-loader";

declare var logoutHeaderChanges: any;
declare var ENV_PORTAL: any;
declare var ENV_VAR: any;

@Component({
  selector: 'app-error-pages',
  templateUrl: './error-pages.component.html',
  styleUrls: ['./error-pages.component.scss']
})

export class ErrorPageComponent implements OnInit {

  errorCode: any;
  errMsg: string;
  msgContent: string;
  errContent: string;
  redirectLink: string;
  user: any;
  accessDenied: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService,
    private pageloaderService: PageLoaderService) {
  }

  ngOnInit() {
    this.pageloaderService.setPageLoaderStatus(true);
    if (this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url] === undefined) {
      document.title = 'AT&T Business Console - Error';
    } else {
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    }
    this.authenticationService.setLoginSuccessUrl('/businessconsole/home');
    this.redirectLink = (ENV_PORTAL === 'fnabc') ? 'Go to the FirstNet home page' : 'Go to AT&T Business Console homepage';
    this.errorCode = this.route.snapshot.params['errorCode'];
    if (this.errorCode != '408' && ERRORCODE[this.errorCode]) {
      this.accessDenied = false;
      this.errMsg = ERRORCODE[this.errorCode].label;
      this.msgContent = ERRORCODE[this.errorCode].value;
      this.errContent = ERRORCODE[this.errorCode].errmsg;
      console.log(this.errMsg);

      this.user = this.authenticationService.getUser();
      if( ENV_PORTAL === 'fnabc' ){
        if( this.user && this.user.fanSignedUpStatus === 'NotEligible' ){ // no permission
          this.errMsg = ERRORCODE[ ENV_PORTAL ]['NO_ELIGIBILITY'].label;
          this.msgContent = ERRORCODE[ ENV_PORTAL ]['NO_ELIGIBILITY'].value;
          this.errContent = ERRORCODE[ ENV_PORTAL ]['NO_ELIGIBILITY'].errmsg;
        }else if( this.errorCode === '403' && this.user.addpAuthority === 'NONE' ){ // no eligible fans // need more work
          this.errMsg = ERRORCODE[ ENV_PORTAL ][this.errorCode].label;
          this.msgContent = ERRORCODE[ ENV_PORTAL ][this.errorCode].value;
          this.errContent = ERRORCODE[ ENV_PORTAL ][this.errorCode].errmsg;
        }
      }
      // else{
      //   this.errMsg = ERRORCODE[this.errorCode].label;
      //   this.msgContent = ERRORCODE[this.errorCode].value;
      //   this.errContent = ERRORCODE[this.errorCode].errmsg;
      // }
    }else if (this.errorCode == '408'){
      this.accessDenied = true;
    }


  }

  redirectToHome() {
    // if (ENV_PORTAL === 'fnabc') {
    //   // tslint:disable-next-line:max-line-length
    //   const url = ENV_VAR === 'prod' ? 'https://fcontent.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&returnURL=https%3A%2F%2Fsolutions.firstnet.att.com%2Fbusinessconsole%2Fhome' :
    //     'https://fcontent.stage.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&returnURL=https%3A%2F%2Fstage-solutions.firstnet.att.com%2Fbusinessconsole%2Fhome';
    //   window.location.href = url;
    // } else {
      this.router.navigate(['/home']);
    // }
  }
}



